module.exports = __webpack_public_path__ + "img/lluvia_blue.d793fed2.svg";